import CollaboratorList from "../../Join/Collaborator/CollaboratorList";

const CollaboratorsTab = (props) => {
  return <CollaboratorList {...props} />;
};

export default CollaboratorsTab;
